<template>
  <div class=" section section_bg   first_page  pb-5" v-if="">


    <div class="col-12 second_section" v-if="is_not_have_access==true">
      <p>Увы , но у вас нет доступа к этой категории блога, чтобы просматривать этот пост. Обратитесь к администратору сайта.</p>
    </div>

    <loading-block v-if="is_not_have_access==false && is_load==false" :loading="!is_load"/>
 <div class="row  blog_posts" v-if="is_load">
   <div class="col-lg-12 col-md-12 col-12 blog_posts_posts    ">
     <div class="d-flex justify-content-center">
     <div class="post_material_mini section_gray_bg second_section mt-4 container">

      <CategoryCardPost v-if="is_load" :category="post_data.category_post"/>
       <p ><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post_data.created_at }}</small></p>





       <div class="post_material_mini" v-if="post_data.is_moderation==true">
         <div class="alert alert-warning">
           Ваш пост еще не проверен администрацией.
           Как только он будет проверен, его увидят все.
           На время проверки ваш пост доступен только по ссылке
         </div>
       </div>
       <div class="post_material_mini">
         <p><i class="fa fa-eye"></i> Просмотров {{ post_data.views }}</p>
       </div>
       <div class="post_material_mini_content" v-if="post_data.content && post_data.content.blocks">
         <editorjsrender  :scroll="true"  :blocks_json="post_data.content.blocks"></editorjsrender>
       </div>
       <div class="post_material_mini_content" v-if="!(post_data.content && post_data.content.blocks)">
         <editorjsrender ref="editorjsrender" :blocks_json="post_data.short.blocks"></editorjsrender>
       </div>
       <div v-if="post_data.sum>0 && islogin==false && post_data.content==null" >
         <p><a href="#" @click="loginReturnBack()" class="btn">Купить {{ post_data.sum }} {{ post_data.currency}}</a></p>
       </div>
       <div v-if="post_data.sum>0 && islogin==true && post_data.content==null" >
         <p><a href="#" class="btn" @click="buyPost()">Купить {{ post_data.sum }} {{ post_data.currency}}</a></p>
       </div>






       <div class="no_spaces_for_div">
         <UserCard   :user="post_data.user" />
       </div>





         <div class="mt-2" v-if="user && ( (user.last_id==post_data.user.last_id) || (post_data.my_access && post_data.my_access.isadmin==1) )">
           <p>
             <router-link tag="a" class="btn mb-1" :to="{name: 'edit_post', params: { id: post_data.last_id }}">
               Редактировать
             </router-link>


             <button class="btn mb-1" @click="toogleEnable" v-if="post_data.enable==1">В черновик</button>
             <button class="btn mb-1" @click="toogleEnable" v-if="post_data.enable==0">Опубликовать</button>
           </p>
         </div>

       <p class="m-3"><i class="fa fa-comments"></i>  ({{ post_data.total_comments_count }})</p>




     </div>
     </div>

     <div class="d-flex justify-content-center mobile_div">


     <div class="row m-2 mobile_div second_section container " v-if="is_load_comments && !(post_data.disable_comments==1 || post_data.category_post.disable_comment==1)">
       <div class="row  ">
         <div class="col-12 row alert alert-warning" v-if="post_data.disable_comments==1 || post_data.category_post.disable_comment==1">
           <p>Увы но комментарии к записи отключены.</p>
         </div>
         <h3 class="ml-3" >Комментарии</h3>
         <div class="col-12 alert alert-warning" v-if="post_data.category_post.is_comment_anonymous==1">
           <p><i class="fa fa-user-secret"></i>Все комментарии под этой записью анонимные. Ваши реальные профили не раскрываются</p>
         </div>
         <div class="row col-12" v-if="post_data.disable_comments==0 && post_data.category_post.disable_comment==0">
           <div class="col-12"  v-if="post_data.comments.length>0" v-for="(comment,comment_index) in post_data.comments">
             <CommentBlock :key="'comment_'+comment_index" @click-remove="(val)=>{deleteComment(comment.last_id,comment_index)}" :isRemove="post_data.my_access && post_data.my_access.isadmin==1"   :comment="comment"/>
             <CommentBlock :key="'comment_'+subcomment.last_id"  @click-remove="(val)=>{deleteSubComment(subcomment.last_id,comment.last_id,index_subcomment,comment_index)}" :isRemove="post_data.my_access && post_data.my_access.isadmin==1"  v-if="comment.comments.length>0" :isSubcomment="1" v-for="(subcomment,subcomment_index) in comment.comments" :comment="subcomment"/>
             <FormCommentBlock :key="'sendsubcomment_'+comment.last_id"     :is_start_send="is_send_comments['comment_'+comment.last_id]"  :comment_text="post_subcomment['comment'+comment.last_id]"

                 @click_button="(subcomment_text) => {
                  post_subcomment['comment'+comment.last_id]=subcomment_text;
                  sendSubComment(comment.last_id,comment_index)
                } "  :user="user"></FormCommentBlock>
           </div>
         </div>
         <FormCommentBlock class="mobile_div" v-if="post_data.disable_comments==0 && post_data.category_post.disable_comment==0"   :is_start_send="is_send_comment_first"  :comment_text="newComment.comment"

             @click_button="(subcomment_text) => {


                  sendComment(subcomment_text);
                } "  :isCanEditorJs="true" :user="user"></FormCommentBlock>
         <div class="col-12 mt-2"  v-if="user && post_data.disable_comments==0 && post_data.category_post.disable_comment==0" >

         </div>
         <div class="col-12" v-if="!(user) && (post_data.disable_comments==0 && post_data.category_post.disable_comment==0)">
           <p class="lead">Пройдите <router-link      :to="{name: 'login',query: { nextUrl: $route.fullPath }}"  tag="a">авторизацию</router-link>
             , чтобы оставить комментарий </p>
         </div>
       </div>
     </div>
     </div>
     </div>






 </div>
  </div>

</template>

<script>
import Api from "@/models/Api";
import Vue from "vue";
import Editorjsrender from "@/models/Editorjsrender";
import {eventBus} from "@/main";
import CommentBlock from "@/components/Custom/CommentBlock";
import FormCommentBlock from "@/components/Custom/FormCommentBlock";
import UserCard from "@/components/Custom/UserCard";
import CategoryCardPost from "@/components/Custom/CategoryCardPost";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "Post",
  data() {
    return {
      is_load: false,
      post_data: null,
      image_url: null,
      is_not_have_access:false,
      is_load_comments:true,
      is_send_comment_first:0,
      background_header: "/img/header_bg.jpg",
      user: null,
      is_send_comments:{},

      islogin: false,
      "new_comment_is_error": false,
      "new_comment_error": null,
      post_subcomment: [],
      "newComment": {
        "comment": null
      },

    }
  },
  mounted() {
    //AppHeader.methods["testLog"]();


    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    let id = app.$route.params.id;


    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }




    });
    Api.loadPost(id, function (data) {
      app.post_data = data;

      if (data.category_post.background && data.category_post.background.length > 0) {

        app.background_header = app.image_url + data.category_post.background;

      }
      app.is_load = true;

    },function(err){
      if(err && err.need_auth ){
        app.$router.push({name: 'login',query: { nextUrl: app.$route.fullPath }});

      }else if(err && err.not_have_access){
        app.is_not_have_access=true;
      } else{
        app.$router.push({name:'404'});
      }

    })


  },
  methods: {

    buyPost(){
      var app=this;
      Api.blogBuyPost(app.post_data.last_id,function(data){
        var route_params={path: '/invoice/'+data.invoice.last_id};
        app.$router.push(route_params)
      },function(error_data){
        alert(error_data);
      })
    },
    loginReturnBack(){
      var app=this;
     var route_params={path: '/login',
       query: { nextUrl: this.$route.fullPath }};
      app.$router.push(route_params)


    },
    openProject( ){
      var app=this;


      let routeData = app.$router.resolve({name: 'project',params: {id: app.post_data.category_post.project.last_id, "rand": Math.random()}});
      window.open(routeData.href, '_self');
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },
    toogleEnable() {
      var app = this;
      Api.changeEnablePost(app.post_data.last_id, function (data) {
        app.post_data = data;
      })
    },
    deleteComment(comment_id, index_comment) {
      var app = this;
      Api.deleteCommentPost(comment_id, app.post_data.last_id, function (data) {
        //   app.post_data.comments = app.post_data.comments.slice();
        //
        app.post_data.comments.splice(index_comment, 1);
      })
    },
    deleteSubComment(subcomment_id, comment_id, index_sub, index_comment) {
      var app = this;
      Api.deleteSubCommentPost(subcomment_id, comment_id, app.post_data.last_id, function (data) {
        //   app.post_data.comments = app.post_data.comments.slice();
        //
        app.post_data.comments[index_comment].comments.splice(index_sub, 1);
      })
    },
    sendSubComment(comment_id, comment_index) {
      var app = this;

      app.is_send_comments["comment_"+comment_id]=1;
      var comment = app.post_subcomment['comment' + comment_id];
      Api.sendPostSubComment(app.post_data.last_id, comment_id, comment, function (comments) {
        app.post_data.comments[comment_index].comments = comments;
        app.post_subcomment['comment' + comment_id] = "";
        app.is_send_comments["comment_"+comment_id]=0;
      });
    },
    sendComment(comment_text) {



      var app = this;
      app.is_send_comment_first=1;

      if(typeof comment_text === 'object'){

        var newComment={};
        newComment.json=comment_text;
      }else {
        var newComment = app.newComment;
        newComment.comment=comment_text;
      }

      app.is_load_comments=false;
      Api.addPostComment(newComment, app.post_data.last_id, function (result_comment) {
        app.iserror = false;
        app.is_send_comment_first=0;
        app.newComment.comment = "";
        var new_comments=app.post_data.comments;
        new_comments.push(result_comment);
        app.$set(app.post_data, 'comments', new_comments)
        //app.post_data.comments=new_comments;
        app.is_load_comments=true;
      }, function (message) {
        app.iserror = true;
        app.is_send_comment_first=0;
        app.error_message = message;
        app.is_load_comments=true;
      })


    },
    callEditPost() {
      var app = this;
      var params = {

        type: "post_edit",
        post_id: app.post_data.last_id,
        modal_title: "Редактировать пост",

        blog_category_default:app.post_data.category_post.last_id,
        blog_category_row:app.post_data.category_post,
        category: app.post_data.category,
        category_post: app.post_data.category_post,
        json: app.post_data.content
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    }
  },
  components: {
    'editorjsrender': Editorjsrender,
    'CommentBlock':CommentBlock,
    'FormCommentBlock':FormCommentBlock,
    'UserCard':UserCard,
    'CategoryCardPost':CategoryCardPost,
    LoadingBlock
  }
}
</script>

<style scoped>

</style>